import { NotificationCategory } from "../../Constants/Enums/Notification.enum";
import { SentNotification } from "../../Models/sentNotification.models";
import { getValue } from "../../utils/object.utils";
import { formatDateBasedOnTimezone } from "../../utils/date.utils";

export const transformSentNotificationListTableData = (
  sentNotificationLists: Array<SentNotification>
): any[] => {
  const transformDatForTable = sentNotificationLists.map(
    (sentNotificationList: SentNotification): any => {
      return {
        id: getValue(sentNotificationList, "id"),
        title: getValue(sentNotificationList, "title", ""),
        text: getValue(sentNotificationList, "text", ""),
        category: getValue(
          sentNotificationList,
          "category",
          NotificationCategory.GENERAL
        ),
        created_at: formatDateBasedOnTimezone(
          getValue(sentNotificationList, "created_at", "")
        ),
      };
    }
  );
  return transformDatForTable;
};
